import { parse, parseISO, format } from "date-fns";

/**
 * 指定したdateが Invalid Date かどうかを判定する
 * @param date
 * @description https://zenn.dev/lollipop_onl/articles/eoz-judge-js-invalid-date
 */
const isInvalidDate = (date: Date) => Number.isNaN(date.getTime());


const parseDate = (dateText: string, enableForceParse: boolean = false) => {
    const v = dateText.replace(/\s/g, '')

    let formatList = []

    // enableForceParse が trueの場合、強制的というほどではないが、
    // フォーマットに引っかかるものはなるべく変換してあげる。
    // enableForceParse が faselの場合、少し厳密に変換する
    // 例えば、/ が含まれる場合、/が2つ含まれて、文字列を3分割できる必要があり、
    // かつ、最後が4, 5, 6, 7, 8, 9, 0なら日付は1桁なので、yyyy/M/dとして変換するが、
    // 1,2,3 の場合には、yyyy/MM/ddで変換する（ただし、date-fnsのparseは yyyy/MM/dd にしても、
    // 日付部分が 03 ではなく 3 だけでも 3日 にしてしまうため、
    // 文字数をチェックして10桁または月が1桁の場合には9桁の場合のみ変換する。

    if (enableForceParse) {
        formatList = ['yyMMdd', 'yyyyMMdd', 'yyyyMdd', 'yyyy/M/d', 'yyyy年M月d日', 'yyyy年MM月dd日']
    } else if (v.includes('/')) {
        const ss = v.split('/');
        if (ss.length == 3) {
            // 日付に4,5,6,7,8,9,0がきたら一桁確定
            if (['4', '5', '6', '7', '8', '0'].includes(ss[2])) {
                formatList = ['yyyy/M/d']
            } else if (v.length == 10 + (ss[1].length - 2)) {
                formatList = ['yyyy/MM/dd']
            }
        }
    } else if (v.length == 8) {
        formatList = ['yyyyMMdd']
    } else if (v.length > 8) {
        formatList = ['yyyy年M月d日', 'yyyy年MM月dd日']
    } else if (v.length == 6) {
        formatList = ['yyMMdd']
    }

    for (let fmt of formatList) {
        const d = parse(v, fmt, new Date());
        if (!isInvalidDate(d) && d.getFullYear() > 1000) {
            return d;
        }
    }

    return null;
}

export default {
    isInvalidDate,
    parseDate
}
